import { Tooltip } from "components/components/tooltip/tooltip";
import { TokenData, TokenizedElement } from "components/input/multivalueText/components/tokenized";
import { ComposedSearcherInput, SearcherWithComposedCodeValue } from "components/input/searcherWithCode/searcherWithComposedCode/searcherWithComposedCode";
import { SearcherParameter } from "components/input/select/options";
import isEqual from "lodash/isEqual";
import { ItemComposedFinderModalDefinition } from "components/input/searcherWithCode/baseItemFinderElement";
import * as itemComposedFinderModal from "components/input/searcherWithCode/baseFunctionsFinderModal";
import { initSearcherMagnifierElementWebComponent, SearcherMagnifierElement } from "./searcherWithComposedCodeMagnifierElement";

const template = document.createElement("template");
template.innerHTML = `
      <style>
      :host(:focus) {
          outline: none;
          border: none;
      }

      s6-searcher-magnifier {
        padding: 0.25rem 0  0.25rem  0.5rem;
        user-select: none;
        position: absolute;
        top: 0;
        right: 0;
        padding: 6px 12px 6px 6px;
        display: inline-block;
      }
      </style>
      <s6-tokenized>
      </s6-tokenized>
      <s6-searcher-magnifier></s6-searcher-magnifier>
    `;

initSearcherMagnifierElementWebComponent();
export class MultiSearcherWithComposedCodeElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private tokens: TokenizedElement;
    private _queryParameters: SearcherParameter[];
    private _finder: ItemComposedFinderModalDefinition;
    private _data: SearcherWithComposedCodeValue[];
    private magnifier: SearcherMagnifierElement;
    private _inputs: ComposedSearcherInput[];

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.appendChild(template.content.cloneNode(true));
        this.setAttribute("data-s6-focusable", "true");
        this.tokens = this._shadowRoot.querySelector("s6-tokenized");
        this.addEventListener("blur", () => {
            this.tokens.blur();
        });
        this.addEventListener("focus", () => {
            this.focus();
        });
        this.tokens.addEventListener("click", () => {
            this.focus();
        });
        this.tokens.addEventListener("change", (e) => {
            this._data = this.data;
            e.stopPropagation();
            this.dispatchEvent(new Event("change"));
        });
        if (!this.hasAttribute("tabindex")) {
            this.tabIndex = 0;
        }
        this.magnifier = this._shadowRoot.querySelector("s6-searcher-magnifier");
        this.magnifier.addEventListener("click", () => {
            let params = {
                data: {
                    filter: this._queryParameters,
                },
            };
            itemComposedFinderModal.open(
                itemComposedFinderModal.EnumSearcherWithType.COMPOSE,
                this._finder,
                params,
                this.modalWindowRowSelectedCallback);
        });

        this.addEventListener("keydown", this.keydown);
        this.addEventListener("keyup", this.keyup);
        Tooltip.bindElement(this);
    }
    private modalWindowRowSelectedCallback = (data: any): void => {
        this._data = this._data ?? [];
        let tokensData = this.tokens.data ?? [];

        for (const d of data) {
            let isContained = false;
            for (const cd of this._data) {
                if (isEqual(cd.code, d.code)) {
                    isContained = true;
                    break;
                }
            }
            if (isContained) {
                continue;
            }
            this._data.push(d);
            tokensData.push({
                texts: Object.values(d.code),
                tooltip: d.detail,
            });
        }
        this.tokens.data = tokensData;
        this.dispatchEvent(new Event("change"));
    }

    private connectedCallback() {
        this.upgradeProperty("readOnly");
    }
    private upgradeProperty(prop) {
        if (this.hasOwnProperty(prop)) {
            let value = this[prop];
            delete this[prop];
            this[prop] = value;
        }
    }

    public set inputs(inputs) {
        this._inputs = inputs;
    }

    public set data(data: SearcherWithComposedCodeValue[]) {
        this._data = data;

        let vd = [] as TokenData[];
        if (this._data != null) {
            for (const item of this._data) {
                let td = {
                    texts: [],
                    tooltip: "",
                }
                for (let index = 0; index < this._inputs.length; index++) {
                    const input = this._inputs[index];
                    td.texts.push(item.code[input.id]);
                }
                td.tooltip = item.detail;
                vd.push(td);
            }
        }

        this.tokens.data = vd;
    }

    public get data(): SearcherWithComposedCodeValue[] {
        if (this.tokens.data == null || this.tokens.data?.length === 0) {
            return null;
        }
        let data = [];
        for (const d of this.tokens.data) {
            let code = {};
            for (let index = 0; index < this._inputs.length; index++) {
                const input = this._inputs[index];
                code[input.id] = d.texts[index];
            }
            data.push({
                code,
                detail: d.tooltip,
            });
        }
        return data;
    }

    public set finder(f) {
        this._finder = f;
    }

    public set queryParameters(qp) {
        this._queryParameters = qp;
    }

    public focus() {
        super.focus();
        this.tokens.focus();
    }

    public set readOnly(ro: boolean) {
        if (ro) {
            this.setAttribute("readonly", "true");
        } else {
            this.removeAttribute("readonly");
        }
        this.tokens.readOnly = ro;
        this.magnifier.readOnly = ro;
    }

    public set valid(valid: boolean) {
        this.tokens.valid = valid;
    }

    public set validationMessage(message) {
        this.tokens.validationMessage = message;
    }
    private keydown  = (e: KeyboardEvent) => {
        if (e.key === " " && !this.hasAttribute("readonly")) {
            e.preventDefault();
        }
    }
    private keyup  = (e: KeyboardEvent) => {
        if (e.key === " " && !this.hasAttribute("readonly")) {
            this.magnifier.dispatchEvent(new Event("click"));
        }
    }
}

export function initMultiSearcherWithComposedCodeElementeWebComponent() {
    window.customElements.define("s6-multi-searcher-with-composed-code", MultiSearcherWithComposedCodeElement);
}
